<template>
<div>

    <van-nav-bar placeholder title="退费" left-text="返回" left-arrow @click-left="onClickLeft()">
    <template #right>
    </template>
  </van-nav-bar>


  <van-form @submit="onSubmit">

    <div class="xy-box">学员姓名：<p>{{ data.studentName }}</p></div>
    <div class="xy-box">退费课时：<p>{{ data.leftHour }}</p></div>
    <div class="xy-box">退费金额：<p><b>￥{{ data.returnPrice}}</b></p></div>
        <van-field  label="图片">
          <template #input>
            <custom-upload ref="upload" />
          </template>
        </van-field>
        <van-field
              rows="4"
              type="textarea"
              maxlength="255"
              class="sm"
              :rules="[{ required: true, message: '请输入退费原因' }]"
              v-model="data.returnDes"
              label="退费说明"
          />
        <van-button round block :loading="formLoading" type="info" native-type="submit" class="floatbox">立即退费</van-button>
  </van-form>
</div>
</template>

<script>

import {getUnpaidDetailById, reimburse} from "../../../api/course/course";
import customUpload from '@/components/customUpload'
import {getDictByType} from "../../../api/common";

export default {
  components:{  customUpload},
name: "returnPremium",
  data(){
  return{
    formLoading:false,
    data:{}
  }
  },
  created() {



    this.data.id = this.$route.query.id
    getUnpaidDetailById(this.$route.query.id).then(res =>{
      if (res.code === 10000){
        this.data = res.result
        this.data.returnPrice = (res.result.price / res.result.classHour) * res.result.leftHour

      }
    })
  },
  methods:{
    onClickLeft(){
      this.$router.push({path: `/course`})
    },


    onSubmit() {
      this.formLoading = true
      const data ={
        returnPic : this.$refs.upload.getFileList().join(','),
        returnDes : this.data.returnDes,
        returnHour : this.data.leftHour,
        applyId : this.data.id,
        returnPrice : this.data.returnPrice
      }
      reimburse(data).then(res =>{
        if (res.code === 10000) {
          this.$toast(res.msg)
          this.$router.push({path: `/course/auditDetail?id=${this.data.id}`})
        }
      }).finally(() => {
        this.formLoading = false
      })
    },
  }
}
</script>

<style scoped>
/deep/.van-field__error-message{
  width: 100%;
}
.xy-box{
  display: flex;
  align-items: center;
  height: 27px;
  font-size:14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  padding: 0 14px;
  margin:10px 0;
  color: #000000;
}
.xy-box p{
  font-size:14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #666666;
}
.xy-box p b{
  font-size:14px;
  font-family: PingFang SC;
  font-weight: bold;
  color:#FF6600;
}
/deep/.van-cell{
  padding:10px  15px;
}
/deep/.van-field__label{
  width:80px;
  font-size:14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
  box-sizing: border-box;
}
/deep/.select .van-field__value {
  height:35px;
  background: #F4F5F7;
  border-radius:100px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
/deep/.sm .van-field__value {
  height: 95px;
  background: #F4F5F7;
  border-radius:6px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  flex-direction: column;
}
/deep/.van-field__body{
  display: flex;
  width: 100%;
}
/deep/.sm .van-field__body{
  min-height:65px;
  align-items: flex-start;
  padding-top:5px;
  overflow-y: auto;
}
/deep/.van-field__word-limit{
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
/deep/.van-field__control{
  display: flex;
}
/deep/.van-cell::after{
  display: none;
}
/deep/.van-uploader__upload{
  width:116px;
  height:74px;
}
/deep/.van-uploader__preview-image{
  width:116px;
  height:74px;
}
</style>
